module.exports = __webpack_public_path__ + "static/1m-e6106d19f0d569aad8ee74ce88dbee50.jpg";